/*
    Purple MobileApp scheme
*/
export const PURPLE_SCHEME_TYPE = {
    CLOSE: 'close',
    EXTERNAL: 'external',
    INAPP: 'inapp',
    WEBVIEW: 'webview'
};

export const PURPLE_SCHEME = {
    [PURPLE_SCHEME_TYPE.CLOSE]: 'nc2://close',
    [PURPLE_SCHEME_TYPE.EXTERNAL]: 'ncmtalk://external?url=', // 외부브라우저 호출
    [PURPLE_SCHEME_TYPE.INAPP]: 'ncmtalk://inappBrowser?url=', // 인앱브라우저 호출
    [PURPLE_SCHEME_TYPE.WEBVIEW]: 'ncmtalk://webview?url=' // 웹뷰 호출
};